import { ActionBase } from '../../../core/store/action/ActionBase';
import { RuleCommonParameterModel } from "../../models/RuleCommonParameterModel";

export const APPLY_COMMON_PARAMETERS = '[Rule] Apply Common Parameters';

export class ApplyCommonParametersAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = APPLY_COMMON_PARAMETERS;

  constructor(public payload: { model: RuleCommonParameterModel }) {

  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/ApplyCommonParametersAction.ts